module.exports = __webpack_public_path__ + "static/img/Group 355.553dc23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Group 355.png
// module id = 84h2
// module chunks = 13